import React from "react";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";
import { Icon } from "@abb/abb-common-ux-react";


interface IPropertyStepsProps {
  isStep: boolean;
}

export default class PropertySteps extends React.Component<IPropertyStepsProps, {}> {
  private _mount: boolean = false;

  constructor(props: IPropertyStepsProps) {
    super(props);
    this._mount = true;
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;
  }

  public render() {
    return (
      <Translation>
        {(t) => (
          <React.Fragment>
            <div className="row mt-3 ml-5">
              <div className="h-25">
                <div className="mb-2">
                  <div
                    className={
                      this.props.isStep
                        ? "float-left border-top-step1-card"
                        : "float-left border-top-step2-card"
                    }
                  >
                    <div className="ml-5 mt-2 step-font">
                      {t(CONSTANTS.STEP1)}
                    </div>
                    <div className="sub-title ml-2 mt-2">
                      {t(CONSTANTS.ASSIGN_THRESHOLD_VALUES)}
                    </div>
                  </div>
                </div>
              </div>

              <div className="">
                <Icon
                  name="abb/right"
                  sizeClass="large"
                  className="ml-2 mt-1"
                />
              </div>

              <div className="w-25 h-25 ml-2">
                <div className="mb-2">
                  <div className="float-left border-top-step2-card">
                    <div className="ml-5 mt-2 step-font">
                      {t(CONSTANTS.STEP2)}
                    </div>
                    <div className="sub-title ml-3 mt-2">
                      {t(CONSTANTS.FORMULA_DEFINITION)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment >
        )
        }
      </Translation>
    );
  }
}
